"use client";

import { Check, Computer, Moon, SunMedium } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { elenailsTheme } from "@/lib/theme";
import { useTheme } from "@/components/theme-provider";
import { LiquidGlassMenuContent } from "@/components/liquid-glass-menu";

const themeClasses = elenailsTheme.classes;
const themeMenu = elenailsTheme.menu;

const themeOptions = [
  { value: "light", label: "Clair", icon: SunMedium },
  { value: "dark", label: "Sombre", icon: Moon },
  { value: "system", label: "Système", icon: Computer },
] as const;

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const currentTheme = theme === "light" || theme === "dark" ? theme : "system";
  const ActiveIcon = currentTheme === "dark" ? Moon : currentTheme === "light" ? SunMedium : Computer;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={themeClasses.themeToggle}
          aria-label="Changer le thème"
        >
          <ActiveIcon data-icon="inline-start" />
        </Button>
      </DropdownMenuTrigger>
      <LiquidGlassMenuContent align="end" sideOffset={themeMenu.accountSideOffset} className={themeClasses.themeToggleMenu} collisionPadding={themeMenu.collisionPadding}>
        <DropdownMenuLabel className={themeClasses.themeToggleLabel}>Affichage</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {themeOptions.map((option) => {
          const Icon = option.icon;
          const active = currentTheme === option.value;
          return (
            <DropdownMenuItem key={option.value} onSelect={() => setTheme(option.value)}>
              <Icon data-icon="inline-start" />
              {option.label}
              {active && <Check data-icon="inline-end" className="ml-auto" />}
            </DropdownMenuItem>
          );
        })}
      </LiquidGlassMenuContent>
    </DropdownMenu>
  );
}
